export const SET_APP_VERSION = "SET_APP_VERSION";
export const SET_FLOOR = "SET_FLOOR";
export const SET_LOCALE = "SET_LOCALE";
export const SET_PLATFORM = "SET_PLATFORM";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_STORE_URL = "SET_STORE_URL";
export const SET_SIZE_SCHEMA = "SET_SIZE_SCHEMA";
export const SET_GEOLOCATION = "SET_GEOLOCATION";
export const SET_LOYALTY_IS_ENABLED = "SET_LOYALTY_IS_ENABLED";
export const SET_LOYALTY_TIER = "SET_LOYALTY_TIER";
export const SET_MEMBERS_DAY_SALE_EVENT = "SET_MEMBERS_DAY_SALE_EVENT";
export const SET_LOYALTY_IS_BENEFIT_AVAILABLE =
  "SET_LOYALTY_IS_BENEFIT_AVAILABLE";
export const SET_LOYALTY_IS_BENEFIT_EVENT_ACTIVE =
  "SET_LOYALTY_IS_BENEFIT_EVENT_ACTIVE";
export const SET_LOYALTY_IS_OPTED_IN = "SET_LOYALTY_IS_OPTED_IN";

// Platforms
export const MOBILE = "mobile";
export const TABLET = "tablet";
export const DESKTOP = "desktop";

// Gender
export const FLOOR_WOMEN = "women";
export const FLOOR_MEN = "men";
export const FLOOR_DEFAULT = "default";

// Loyalty
export const MEMBERS_ONLY_SALE = "MembersOnlySale";
export const MEMBERS_SALE_LIVE = "MembersSaleLive";
export const MEMBERS_PRE_SALE = "MembersPreSale";
export const EARLY_ACCESS_SALE = "EarlyAccessToSale";
